import { clsx } from 'clsx'

import { Typography } from '@/src/elements/text/Typography'
import { LinkifyText } from '@/src/general/components/LinkifyText'

import type { TChatMessageProps } from '../ChatMessage.types'
import { ChatMessageBubble } from '../ChatMessageBubble'
import { ChatMessageHeader, type TChatMessageHeaderProps } from '../ChatMessageHeader'
import { ChatMessageTextWrapper } from '../ChatMessageTextWrapper'
import { ChatMessageTimestamp } from '../ChatMessageTimestamp'

type TChatMessageSimpleProps = Pick<
  TChatMessageProps,
  'createdAt' | 'firstOfBatch' | 'isSender' | 'lastOfBatch' | 'onDeleteMessage' | 'onReportMessage' | 'showWarning'
> & {
  text: string
  header?: Omit<TChatMessageHeaderProps, 'color'>
}

export const ChatMessageSimple = ({
  createdAt,
  firstOfBatch,
  header,
  isSender,
  lastOfBatch,
  onDeleteMessage,
  onReportMessage,
  showWarning,
  text,
}: TChatMessageSimpleProps) => {
  const color = isSender ? 'white' : 'default'

  return (
    <ChatMessageTextWrapper
      createdAt={createdAt}
      isSender={isSender}
      lastOfBatch={lastOfBatch}
      onDeleteMessage={onDeleteMessage}
      onReportMessage={onReportMessage}
      showWarning={showWarning}
    >
      {({ mainLastOfBatch }) => (
        <ChatMessageBubble
          lastOfBatch={mainLastOfBatch}
          firstOfBatch={firstOfBatch}
          isSender={isSender}
          className={clsx('px-4 py-2', isSender ? 'bg-secondary-bg-inverse' : 'bg-white')}
        >
          {header && <ChatMessageHeader {...header} color={color} />}
          <Typography contrast={isSender ? 'high' : 'default'} colors={color} className="max-w-full">
            <LinkifyText text={text} />
          </Typography>
          {mainLastOfBatch && <ChatMessageTimestamp color={color} createdAt={createdAt} />}
        </ChatMessageBubble>
      )}
    </ChatMessageTextWrapper>
  )
}
